$(->
  if $('.employee-access-management-select2').length > 0
    $('.employee-access-management-select2').select2({
        theme: "bootstrap"
    })

  hideSelectors = () ->
    $('#association-selectors').hide()

  showSelectors = () ->
    $('#association-selectors').show()

  showAdminMessage = () ->
    $('#admin-access-message').show()
    $('#admin-access-message').removeClass('hidden')

  hideAdminMessage = () ->
    $('#admin-access-message').hide()

  showNoAccessMessage = () ->
    $('#no-access-message').show()
    $('#no-access-message').removeClass('hidden')

  hideNoAccessMessage = () ->
    $('#no-access-message').hide()

  $('#app_user_attributes_role').change((evt) ->
    # Roles 1: Admin, 2: Full access, 3: Limited Access, 4: No Recruiting Access
    value = Number(evt.target.value);

    if value == 1
      hideSelectors()
      hideNoAccessMessage()
      showAdminMessage()
    else if value == 2 || value == 3
      showSelectors()
      hideAdminMessage()
      hideNoAccessMessage()
    else if value == 4
      hideSelectors()
      hideAdminMessage()
      showNoAccessMessage()

    # If account has no access hide job permission options
    if value < 4
      $('#job_permission_options').closest('fieldset').show()
    else
      $('#job_permission_options').closest('fieldset').hide()
  ).change()

  # show/hide current password field when email field is edited
  $(document).on 'input', '.manage.settings #userInfo input#app_user_attributes_email', (e) ->
    return unless $('.current-password').length > 0
    return if $('.current-password-wrapper').hasClass('active')
    $('.current-password').removeClass('hidden')
    $('.current-password-wrapper').addClass('active')
)
